import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Header.css';
import useLanguage from '../hooks/useLanguage';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, toggleLanguage } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
      <div className="container">
        <a className="navbar-brand" href="#home">
          <img src="/logo-levitztax.png" alt="LevitzTax" style={{ height: '50px' }} />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="#home">{t('header', 'home')}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#services">{t('header', 'services')}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">{t('header', 'about')}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">{t('header', 'contact')}</a>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={toggleLanguage}>
                {t('header', 'langToggle')}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
